import { render, staticRenderFns } from "./boardCanvas.vue?vue&type=template&id=353f003a&scoped=true"
import script from "./boardCanvas.vue?vue&type=script&lang=js"
export * from "./boardCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f003a",
  null
  
)

export default component.exports